<div class="mu-shell" [class.dark]="isDark">
  <ngx-loading [show]="apiHook.isLoading()"></ngx-loading>

  <!-- ══════════════════════════════════════════════════════
       LIST VIEW
  ══════════════════════════════════════════════════════ -->
  <div *ngIf="isList" class="mu-list-view">

    <!-- HUD bar -->
    <div class="mu-hud">
      <div class="mu-hud__left">
        <div class="mu-hud__icon-wrap">
          <mat-icon>manage_accounts</mat-icon>
        </div>
        <span class="mu-hud__title">Manage Users</span>
      </div>

      <div class="mu-hud__center">
        <div class="mu-search-wrap">
          <app-search-field
            [value]="searchValue"
            [areaLabel]="'ADMIN_MANAGE_USER.SEARCH_AREA_LABEL' | translate"
            (onSearchEvent)="onSearch($event)"
          ></app-search-field>
        </div>
      </div>

      <div class="mu-hud__right">
        <button class="mu-btn mu-btn--primary" type="button" (click)="onAddUser()">
          <mat-icon>person_add</mat-icon>
          <span>{{ 'ADMIN_MANAGE_USER.ADD_BUTTON_TEXT' | translate }}</span>
        </button>
      </div>
    </div>

    <div class="mu-grid-wrap">
      <app-users-list
        [setItems]="listUsers"
        [setSearchValue]="searchValue"
        [deleteUserFromList]="deletedUid"
        (onItemClick)="toggleView($event)"
        (onDelete)="onDeleteUser($event)"
      ></app-users-list>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════
       DETAIL / EDIT VIEW  — gaming console player profile
  ══════════════════════════════════════════════════════ -->
  <div *ngIf="!isList" class="mu-detail-view">

    <!-- ── top chrome bar ── -->
    <div class="mu-chrome">
      <div class="mu-chrome__left">
        <button class="mu-chrome__back" type="button" (click)="toggleView(null)">
          <mat-icon>chevron_left</mat-icon>
          <span>ROSTER</span>
        </button>
        <div class="mu-chrome__sep"></div>
        <span class="mu-chrome__breadcrumb">AGENT PROFILE</span>
        <span class="mu-chrome__breadcrumb mu-chrome__breadcrumb--active">
          / {{ user?.username }}
        </span>
      </div>
      <div class="mu-chrome__right" *ngIf="selectedCognitoUser">
        <button class="mu-btn mu-btn--ghost-outline" type="button" (click)="onSetNewPassword()">
          <mat-icon>lock_reset</mat-icon>
          <span>{{ 'ADMIN_MANAGE_USER.SET_NEW_PASSWORD_BUTTON_TEXT' | translate }}</span>
        </button>
        <button class="mu-btn mu-btn--primary" type="button" (click)="onUpdateUser()" [disabled]="userForm.invalid">
          <mat-icon>save</mat-icon>
          <span>{{ 'BUTTON.SAVE' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- error -->
    <div class="mu-error-banner" *ngIf="errorMessage">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <form #userForm="ngForm" class="mu-profile-scroll">
      <div class="container-fluid px-3 px-lg-4">
        <div class="row g-3 g-xl-4">

          <!-- ══ LEFT SIDEBAR ══ -->
          <div class="col-12 col-lg-3 col-xl-3">

            <!-- ── Player card ── -->
            <div class="mu-player-card" *ngIf="user?.cognito">
              <!-- scanlines -->
              <div class="mu-player-card__scanlines"></div>
              <!-- corner notch -->
              <div class="mu-player-card__notch"></div>

              <!-- avatar zone -->
              <div class="mu-player-card__avatar-zone">
                <div class="mu-player-card__avatar-ring"
                     [class.mu-player-card__avatar-ring--on]="user?.enabled"
                     [class.mu-player-card__avatar-ring--off]="!user?.enabled">
                  <div class="mu-player-card__avatar-inner"
                       *ngIf="user?.groups?.includes('AGENT') || user?.groups?.includes('TEAM_LEAD'); else noAvatar">
                    <app-image-picker
                      [isRounded]="true"
                      [keyPrefix]="user.cognitoId"
                      [image]="user.avatarUrl"
                      (onImageSelect)="onAvatarSelect($event)"
                    ></app-image-picker>
                  </div>
                  <ng-template #noAvatar>
                    <div class="mu-player-card__avatar-fallback">
                      <mat-icon>person</mat-icon>
                    </div>
                  </ng-template>
                </div>

                <!-- status pill -->
                <div class="mu-player-card__status-pill"
                     [class.mu-player-card__status-pill--on]="user?.enabled"
                     [class.mu-player-card__status-pill--off]="!user?.enabled">
                  <span class="mu-player-card__status-dot"></span>
                  {{ user?.enabled ? 'ACTIVE' : 'OFFLINE' }}
                </div>
              </div>

              <!-- username -->
              <div class="mu-player-card__username">{{ user?.username }}</div>
              <div class="mu-player-card__role-row">
                <span class="mu-player-card__role-chip" *ngFor="let g of user?.groups">{{ g }}</span>
              </div>

              <!-- enable toggle -->
              <div class="mu-player-card__toggle-row">
                <span class="mu-player-card__toggle-label">ACCOUNT STATUS</span>
                <mat-slide-toggle name="userenabled" [(ngModel)]="user.enabled" color="primary">
                  <span class="mu-player-card__toggle-text">
                    {{ user?.enabled ? 'ENABLED' : 'DISABLED' }}
                  </span>
                </mat-slide-toggle>
              </div>
            </div>

            <!-- ── System info card ── -->
            <div class="mu-sys-card" *ngIf="user?.cognito">
              <div class="mu-sys-card__header">
                <mat-icon>terminal</mat-icon>
                <span>SYS INFO</span>
              </div>
              <div class="mu-sys-card__body">
                <div class="mu-sys-row">
                  <span class="mu-sys-row__key">UID</span>
                  <span class="mu-sys-row__val mu-sys-row__val--mono">{{ user.cognitoId }}</span>
                </div>
                <div class="mu-sys-row">
                  <span class="mu-sys-row__key">STATUS</span>
                  <span class="mu-sys-badge"
                        [class.mu-sys-badge--ok]="user.cognito.UserStatus === 'CONFIRMED'">
                    {{ user.cognito.UserStatus }}
                  </span>
                </div>
                <div class="mu-sys-row">
                  <span class="mu-sys-row__key">CREATED</span>
                  <span class="mu-sys-row__val">{{ user.cognito.UserCreateDate | date:'dd MMM yyyy' }}</span>
                </div>
                <div class="mu-sys-row">
                  <span class="mu-sys-row__key">MODIFIED</span>
                  <span class="mu-sys-row__val">{{ user.cognito.UserLastModifiedDate | date:'dd MMM yyyy' }}</span>
                </div>
              </div>
            </div>

          </div>

          <!-- ══ MAIN CONTENT ══ -->
          <div class="col-12 col-lg-9 col-xl-9">
            <div class="row g-3">

              <!-- ── Identity panel ── -->
              <div class="col-12" *ngIf="user?.cognito">
                <div class="mu-section">
                  <div class="mu-section__header">
                    <div class="mu-section__header-icon"><mat-icon>badge</mat-icon></div>
                    <span class="mu-section__title">IDENTITY</span>
                    <div class="mu-section__header-line"></div>
                  </div>
                  <div class="mu-section__body">
                    <div class="row g-3">
                      <div class="col-12 col-sm-6">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.USERNAME_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput name="username" [(ngModel)]="user.username" [disabled]="true" required />
                          <mat-icon matSuffix>alternate_email</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6" *ngIf="user?.groups?.includes('AGENT')">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.DISPLAY_NAME_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput name="displayname" [(ngModel)]="user.displayName" required />
                          <mat-icon matSuffix>drive_file_rename_outline</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.EMAIL_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput name="email" [(ngModel)]="user.email" required />
                          <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.PHONE_NUMBER_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput name="phone" [(ngModel)]="user.phoneNumber" required />
                          <mat-icon matSuffix>phone_iphone</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── Roles & Skills + Team & Voice side by side ── -->
              <div class="col-12 col-md-6" *ngIf="user?.cognito">
                <div class="mu-section mu-section--full">
                  <div class="mu-section__header">
                    <div class="mu-section__header-icon"><mat-icon>military_tech</mat-icon></div>
                    <span class="mu-section__title">ROLES & SKILLS</span>
                    <div class="mu-section__header-line"></div>
                  </div>
                  <div class="mu-section__body">
                    <div class="row g-3">
                      <div class="col-12">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.GROUPS_SELECT_PLACEHOLDER' | translate }}</mat-label>
                          <mat-select multiple [(value)]="user.groups">
                            <mat-option [value]="group" *ngFor="let group of allGroups">{{ group }}</mat-option>
                          </mat-select>
                          <mat-icon matSuffix>groups</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12" *ngIf="user?.groups?.includes('AGENT')">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.SPECIALIZATION_SELECT_PLACEHOLDER' | translate }}</mat-label>
                          <mat-select multiple name="specialization" [(ngModel)]="user.keywords">
                            <mat-option *ngFor="let topic of allKeywords" [value]="topic">{{ topic }}</mat-option>
                          </mat-select>
                          <mat-icon matSuffix>psychology</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12" *ngIf="user?.groups?.includes('AGENT')">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.LOCALE_SELECT_PLACEHOLDER' | translate }}</mat-label>
                          <mat-select multiple name="locale" [(ngModel)]="user.locales">
                            <mat-option *ngFor="let locale of Locale" [value]="locale.code">
                              {{ locale.name }} ({{ locale.code }})
                            </mat-option>
                          </mat-select>
                          <mat-icon matSuffix>language</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6" *ngIf="user?.cognito">
                <div class="mu-section mu-section--full">
                  <div class="mu-section__header">
                    <div class="mu-section__header-icon"><mat-icon>headset_mic</mat-icon></div>
                    <span class="mu-section__title">TEAM & VOICE</span>
                    <div class="mu-section__header-line"></div>
                  </div>
                  <div class="mu-section__body">
                    <div class="row g-3">
                      <div class="col-12" *ngIf="user?.groups?.includes('AGENT')">
                        <div class="mu-team-field">
                          <app-team-input-autocomplete
                            [initialTeamId]="user.teamId"
                            (selectionChange)="teamCtrl.setValue($event)"
                          ></app-team-input-autocomplete>
                        </div>
                      </div>
                      <div class="col-12">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.VOICE_INTEGRATION.VOICE_USERNAME_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput name="voiceUsername" [(ngModel)]="user.voiceUsername" />
                          <mat-icon matSuffix>record_voice_over</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── CMS Integrations ── -->
              <div class="col-12" *ngIf="user?.cmsUserData">
                <div class="mu-section">
                  <div class="mu-section__header">
                    <div class="mu-section__header-icon"><fa-icon [icon]="faTasks"></fa-icon></div>
                    <span class="mu-section__title">{{ 'ADMIN_MANAGE_USER.CMS_INTEGRATIONS.TITLE' | translate }}</span>
                    <div class="mu-section__header-line"></div>
                    <button mat-icon-button class="mu-section__add-btn"
                            *ngIf="freeCmsTypes.length > 0"
                            [matMenuTriggerFor]="cmsMenu"
                            [title]="'ADMIN_MANAGE_USER.CMS_INTEGRATIONS.ADD_BUTTON_TEXT' | translate">
                      <mat-icon>add_circle_outline</mat-icon>
                    </button>
                    <mat-menu #cmsMenu="matMenu">
                      <button mat-menu-item *ngFor="let cmsType of freeCmsTypes" (click)="onAddCms(cmsType)">
                        {{ cmsType }}
                      </button>
                    </mat-menu>
                  </div>
                  <div class="mu-section__body">
                    <div class="mu-cms-empty" *ngIf="user.cmsUserData.length === 0">
                      <mat-icon>extension_off</mat-icon>
                      <span>No integrations configured</span>
                    </div>
                    <div class="row g-3 align-items-center" *ngFor="let cms of user.cmsUserData; let i = index">
                      <div class="col-12 col-sm-5">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.CMS_INTEGRATIONS.TYPE_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput [name]="'cmsType' + cms.type" [value]="cms.type" [disabled]="true" required />
                          <mat-icon matSuffix>integration_instructions</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-5">
                        <mat-form-field appearance="outline" class="mu-field">
                          <mat-label>{{ 'ADMIN_MANAGE_USER.CMS_INTEGRATIONS.USER_ID_INPUT_PLACEHOLDER' | translate }}</mat-label>
                          <input matInput [name]="'cmsUserId' + cms.type" [(ngModel)]="cms.userId" required />
                          <mat-icon matSuffix>fingerprint</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-2 d-flex justify-content-center">
                        <button mat-icon-button class="mu-delete-btn" (click)="onDeleteCms(i)"
                                [title]="'ADMIN_MANAGE_USER.CMS_INTEGRATIONS.DELETE_BUTTON_TEXT' | translate">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- /main content -->

        </div>
      </div>
    </form>
  </div>
  <!-- /detail view -->

</div>
